import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "element"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "accordion" };
const _hoisted_4 = { class: "subtitle mt-1" };
import UArrow from "@/components/uikit/uComponents/UArrow.vue";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HowItWorks',
    setup(__props) {
        const openIndex = ref(null);
        const toggle = (index) => {
            openIndex.value = openIndex.value === index ? null : index;
        };
        const steps = [
            {
                title: "Choose Property",
                subtitle: "Due diligence & yield data included.",
                icon: "/img/capital/step1.svg"
            },
            "arrow",
            {
                title: "Invest from AED 1000",
                subtitle: "Fractional share via DIFC SPV.",
                icon: "/img/capital/step2.svg"
            },
            "arrow",
            {
                title: "Earn Returns",
                subtitle: "Rental income paid monthly.",
                icon: "/img/capital/step3.svg"
            },
            "arrow",
            {
                title: "Exit",
                subtitle: "Hold to completion for maximum yield.",
                icon: "/img/capital/step4.svg"
            }
        ];
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UList = _resolveComponent("UList");
            const _component_UContent = _resolveComponent("UContent");
            return (_openBlock(), _createBlock(_component_UContent, {
                "has-padding": false,
                "has-title-delimiter": false
            }, {
                header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" How it works ", -1)
                    ]))]),
                default: _withCtx(() => [
                    _createVNode(_component_UContent, { "is-card-bordered": true }, {
                        default: _withCtx(() => [
                            _createVNode(_component_UList, {
                                "flex-direction": "row",
                                "justify-content": "space-between",
                                "align-items": "flex-start"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, i) => {
                                        return _createElementVNode("div", { key: i }, [
                                            (typeof step === 'object')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                    _createVNode(_component_UIcon, {
                                                        "icon-size": "46px",
                                                        icon: step.icon
                                                    }, null, 8, ["icon"]),
                                                    _createElementVNode("span", {
                                                        class: "title",
                                                        onClick: ($event) => (toggle(i))
                                                    }, [
                                                        _createTextVNode(_toDisplayString(step.title) + " ", 1),
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["arrow", { 'arrow-up': openIndex.value === i }])
                                                        }, [
                                                            _createVNode(_component_UIcon, {
                                                                "icon-size": "12px",
                                                                icon: "chevron_down_green"
                                                            })
                                                        ], 2)
                                                    ], 8, _hoisted_2),
                                                    _createElementVNode("div", _hoisted_3, [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["show-info", { 'show-info-open': openIndex.value === i }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_4, _toDisplayString(step.subtitle), 1)
                                                        ], 2)
                                                    ])
                                                ]))
                                                : (_openBlock(), _createBlock(UArrow, {
                                                    key: 1,
                                                    class: "arrow-container",
                                                    direction: "right",
                                                    variant: "solid",
                                                    length: 18
                                                }))
                                        ]);
                                    }), 64))
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
